export const Notes = [
  {
    title: "House Jobs:",
    id: "1550353655476",
    isFavorite: false,
    color: "#ffffff",
    dateCreated: "2015-03-25",
    deadline: "December 25, 2025",
    tasks: [
      {
        id: "41314",
        text: "Clean the courtyard",
        isDone: true
      },
      {
        id: "41351",
        text: "Wash the car",
        isDone: false
      }
    ]
  },
  {
    title: "To do Tomorrow:",
    id: "102",
    isFavorite: false,
    color: "#ffffff",
    dateCreated: "16.02.2019, 22:43:28",
    deadline: "December 25, 2025",
    tasks: [
      {
        id: "41831",
        text: "Workout",
        isDone: false
      },
      {
        id: "41031",
        text: "Job interview",
        isDone: false
      }
    ]
  },
  {
    title: "To do in Weekend:",
    id: "103",
    color: "#ffffff",
    isFavorite: false,
    dateCreated: "19.02.2019, 22:43:28",
    deadline: "December 25, 2025",
    tasks: [
      {
        id: "41131",
        text: "CoC Session",
        isDone: false
      },
      {
        id: "41431",
        text: "Bike Trip",
        isDone: true
      }
    ]
  },
  {
    title: "My Secret Note",
    id: "104",
    color: "#ffffff",
    isFavorite: true,
    dateCreated: "19.02.2019, 22:43:28",
    deadline: "December 25, 2025",
    tasks: [],
    text:
      "This is my secret note: 59 6f 75 20 61 72 65 20 61 77 65 73 6f 6d 65 21"
  }
];
